export default __webpack_public_path__ + "slices/main/assets/public/media/tinypulse-logo.781b9d23ac93ea2b13e90956d1db5a8e.png";